import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../redux/actions/AuthenticationActions';
import { getUserProfileAndPermissions } from '../../redux/actions/UserProfileActions';
import { updateGeosuggestLanguageSettings } from '../../redux/actions/UtilsActions';

import { Departments } from '../../lib/systemVariables';

import { LanguageTypes } from '../../lib/constants';

class AuthRoute extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false
        }
    }

    componentWillMount() {
        this.requestUserInfo();
    }

    componentWillReceiveProps(nextProps) {
        const authRoute = this.isAuthRoute(nextProps.path);
        if (authRoute !== this.isAuthRoute(this.props.path)) {
            this.setState({
                ready: false,
            }, this.requestUserInfo);
        }
    }

    isAuthRoute(route) {
        return route === "/login" || route === "/verify-login" || route === "/recover-password" || route.indexOf("/reset-password") === 0 || route.indexOf("/set-password") === 0;
    }

    async requestUserInfo() {
        await this.props.actions.getUserProfileAndPermissions();

        // Maybe only update if only belong to 1 department, cuz default is US and then won't mess up if on a specific page????
        if (this.props.userProfile.departments && this.props.userProfile.departments.length === 1) {
            if (this.props.userProfile.departments.indexOf(Departments.IL) > -1 && this.props.languageSettings.language !== LanguageTypes.Hebrew) {
                window.google = undefined;
                this.props.actions.updateGeosuggestLanguageSettings({ language: LanguageTypes.Hebrew, loading: true });
            } else if (this.props.userProfile.departments.indexOf(Departments.US) > -1 && this.props.languageSettings.language !== LanguageTypes.English) {

                window.google = undefined;
                this.props.actions.updateGeosuggestLanguageSettings({ language: LanguageTypes.English, loading: true });
            }
        }
        this.setState({ ready: true });
    }

    render() {
        const { component: Component, ...rest } = this.props;
        let redirect = false, redirectPath = "/";
        if (this.state.ready) {
            const authRoute = this.isAuthRoute(this.props.location.pathname);
            redirect = authRoute ? !!this.props.userProfile.userId : !this.props.userProfile.userId;
            redirectPath = authRoute ? "/" : "/login";
        }

        return (
            <Route {...rest} render={props => this.state.ready ?
                (redirect ? <Redirect to={{
                    pathname: redirectPath, state: {
                        ...props.location.state,
                        from: props.location.pathname + props.location.search
                    }
                }} />
                    : <Component {...props} />) : null
            } />
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        userProfile: state.userProfile.profile.data,
        languageSettings: state.utils.geosuggestLanguageSettings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...authenticationActions, getUserProfileAndPermissions, updateGeosuggestLanguageSettings }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthRoute);


// WEBPACK FOOTER //
// ./src/components/layoutComponents/AuthRoute.jsx